import type { FormValues } from '../types/template.ts'
import { EMPTY_CONTENT } from './empty-content.ts'

export const NEW_TEMPLATE_INITIAL_VALUES: FormValues = {
  isEnabled: true,
  name: '',
  type: 'lease'
}

export const NEW_TEMPLATE_CONTENT = EMPTY_CONTENT
